import AIReviewDotRating from "../AIReview/AIReviewDotRating";

export enum AITweakInteractionStatus {
    PENDING = "pending",
    IN_PROGRESS = "in_progress",
    CANCELED = "canceled",
    IDLE = "idle",
    COMPLETED = "completed",
    FAILED = "failed"
}

export enum AITweakSource {
    USER = "user",
    AGENT = "agent",
}

export enum AITweakStatus {
    PENDING = "pending",
    IDLE = "idle",
    IN_PROGRESS = "in_progress"
}

export default interface AITweak {
    _id: string;
    createdAt?: string;
    updatedAt?: string;
    status: AITweakStatus;
    interactions: AITweakInteraction[];
}

export interface AITweakInteraction {
    _id?: string;
    source?: AITweakSource;
    status: AITweakInteractionStatus;
    screen?: string;
    message?: string;
    rating?: AIReviewDotRating;
    createdAt?: string;
    updatedAt?: string;
}

export interface CreateAITweakPayload {
    _id: string;
    status: AITweakStatus;
    interaction: AITweakInteraction;
}

export interface SetAITweakChatRatingPayload {
    pid: string;
    airid: string;
    lineId: string;
    rating: AIReviewDotRating;
}
